export default __webpack_public_path__ + "static/media/support-notes-logo-mundo-ejecutivo.75b5fdc8.svg";